import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NgClass } from '@angular/common';
import { AddWellModalComponent } from 'app/modules/well-header-information/pages/assets/platform/add-well-modal/add-well-modal.component';
import { EditPlatformModalComponent } from 'app/modules/well-header-information/pages/assets/platform/edit-platform-modal/edit-platform-modal.component';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { PlatformClass } from 'app/modules/well-header-information/model/assets.model';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-platform',
  templateUrl: './platform.component.html',
  standalone: true,
  imports: [
    NgClass
  ],
  styleUrls: ['./platform.component.scss']
})
export class PlatformComponent {
  public platform: PlatformClass;

  constructor(
    private route: ActivatedRoute,
    private wellHeaderService: WellHeaderInfoService,
    private dialog: MatDialog,
  ) { }
  
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      let platformId = params.get('platformId');
      this.getPlatform(platformId)
    });
  }
  
  getPlatform(id: any) {
    this.wellHeaderService.getPlatformById(id).subscribe((res) => {
      this.platform = {
        platformId: res.data.id,
        fieldId: res.data.fieldId,
        name: res.data.platformShortName,
        longName: res.data.platformLongName,
        status: res.data.platformStatus,
        remarks: res.data.remark,
        createdDate: res.data.inputDate,
        level: 'platform'
      };
    })
  }

  addWellModal(platformDetails: any) {
    const dialogRef = this.dialog.open(AddWellModalComponent, {
      data: platformDetails.platformId,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  editPlatformModal(platformData: any) {
    const dialogRef = this.dialog.open(EditPlatformModalComponent, {
      data: platformData,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.getPlatform(platformData.platformId)
      }
    });
  }

  handleDateFormat(dateString: string, withTime: boolean = false){
    return handleFormatDate(dateString,withTime)
  }
}
